import {useContext} from 'react';
import { useParams } from 'react-router-dom';
import { ApiContext } from '../context/Api';
import {useQuery} from "@tanstack/react-query";

const USER_INFO = 'userInfo';

function LessonModel() {
  const { apiService } = useContext(ApiContext);
  const { lessonSlug } = useParams();
  const id = lessonSlug.substring(0, lessonSlug.indexOf('-'));
  const user = JSON.parse(localStorage.getItem(USER_INFO));

  // Get lesson
  const {
    data,
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: ['getLesson', id],
    queryFn: async () => {
      const response = await apiService.getLesson(id);
      if (!response || !response.data || !response.data.lesson) {
        throw new Error('Invalid response');
      }
      return response.data.lesson;
    },
    select: (data) => {
      if (data) {
        const blocks = data.content || data.blocks;
        data.blocksData = blocks.reduce((result, block) => {
          let { type } = block;
          if (!type) return result;
          if (type === 'questions') {
            type = 'scripture'; // combine questions into the scripture section
          }
          if (!result[type]) {
            result[type] = [];
          }
          result[type].push(block);
          return result;
        }, {});
      }
      return data;
    },
  });

  // Get user answers
  const { data: answers } = useQuery({
    enabled: !!user?.user?.id,
    placeholderData: [],
    initialData: [],
    staleTime: 0,
    queryKey: ['getUserAnswers', user],
    queryFn: async () => {
      const response = await apiService.getUserAnswers(user);
      if (!response || !response.data || !response.data.answers) {
        throw new Error('Invalid response');
      }
      return response.data.answers || [];
    },
  });

  return {
    id,
    lesson: data,
    answers,
    isLoading,
    isError,
    refetch,
  };
}
export default LessonModel;
